import React from "react";
import {
  Anchor,
  VideoPlayerPoster,
} from "discover.medical.react-component-library";

import {
  CardWrapper,
  CardMediaWrapper,
  ImageWrapper,
  InfoWrapper,
} from "./_styled";
import ViewInContextMenu from "../ViewInContextMenu";

const MediaItem = ({
  index,
  title,
  associatedTopics,
  type,
  imageSrc,
  imageSrcSet,
  imageSize,
  videoUrl,
  openLightBox,
  isMobileDevice,
  isTabletDevice,
}) => {
  return (
    <CardWrapper
      size="lg"
      backgroundColor="gray100"
      borderColor="gray400"
      borderStyle="solid"
      borderWidth="1px"
    >
      <CardMediaWrapper $shouldSetMinHeight={type !== "videos"}>
        {type === "videos" ? (
          <VideoPlayerPoster
            url={videoUrl}
            onClick={(e) => {
              e.preventDefault();
              openLightBox(index);
            }}
            inheritSize={true}
            lazyLoad={false}
            alt={title}
          />
        ) : (
          <ImageWrapper
            data-testid="image-container"
            src={imageSrc}
            srcSet={imageSrcSet}
            sizes={imageSize}
            alt={title}
            onClick={(e) => {
              e.preventDefault();
              openLightBox(index);
            }}
          />
        )}
      </CardMediaWrapper>
      <InfoWrapper container justify={{ content: "space-between" }}>
        <Anchor
          data-testid="image-title"
          onClick={(e) => {
            e.preventDefault();
            openLightBox(index);
          }}
        >
          {title}
        </Anchor>
        {associatedTopics &&
          ViewInContextMenu({
            associatedTopics: associatedTopics,
            isMobileDevice,
            isTabletDevice,
          })}
      </InfoWrapper>
    </CardWrapper>
  );
};

export default MediaItem;
